<template>
  <v-bar-chart-card
    title="금일 작업현황"
    is-move-detail
    :series="series"
    :colors="['#cdcdcd', '#927dfa', '#3c3c3c']"
    :categories="categories"
    total-label="작업총계"
    count-label="공장별 작업총계"
    :total-count="totalCount"
    :category-counts="categoryCounts"
    :loading="isLoading"
    @detail="onClickDetail"
  >
    <template #right-buttons>
      <span class="btn-border py-1 px-2" :class="boardId === 976 && 'active'" @click="onClickSearch('외부')">외부</span>
      <span class="btn-border py-1 px-2" :class="boardId === 981 && 'active'" @click="onClickSearch('내부')">내부</span>
    </template>
  </v-bar-chart-card>
</template>

<script>
import VBarChartCard from "@/components/chart/VBarChartCard.vue";

export default {
  name: "VBarChart305",
  components: { VBarChartCard },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    totalCount() {
      let total = 0;
      this.series.forEach((item) => {
        item.data.forEach((data) => {
          total += data;
        });
      });

      return total.toLocaleString();
    },
    categoryCounts() {
      const counts = [];
      this.categories.forEach((item) => {
        counts.push({
          name: item,
          count: 0,
        });
      });
      this.series.forEach((item) => {
        item.data.forEach((data, index) => {
          counts[index].count += data;
        });
      });
      return counts;
    },
  },
  watch: {
    dataType(/*value*/) {
      this.loadGraph();
    },
  },
  data() {
    return {
      graphId: 305,
      steps: ["등록", "입문", "작업중", "작업완료", "출문"],
      series: [
        { name: "등록", step: "등록", data: [0, 0, 0, 0], group: "single" }, // 단독 막대
        { name: "작업 중", step: "작업중", data: [0, 0, 0, 0], group: "group" }, // 스택 그룹
        { name: "작업 완료", step: "작업완료", data: [0, 0, 0, 0], group: "group" }, // 스택 그룹
      ],
      categories: ["본사", "인천공장", "포항공장", "당진공장", "중앙기술연구소"],
      boardId: 976,
      isLoading: false, // 로딩 상태
    };
  },
  async mounted() {
    await this.loadPostList(this.boardId);
  },
  methods: {
    onClickDetail() {
      const projectId = this.$route.params.proj_id;
      if (projectId) {
        this.$router.push(`/project/${projectId}/dashboard`);
      } else {
        this.$router.push(`/project/2/dashboard`);
      }
    },
    onClickSearch(type) {
      if (type === "외부") {
        this.boardId = 976;
      } else if (type === "내부") {
        this.boardId = 981;
      }

      this.loadPostList(this.boardId);
    },

    // FactoryAccessDashboard.vue 와 동일
    statusNumber(body, workers) {
      const checkUserIds = (body.users || []).map((user) => Number(user.id));
      const json = {};
      for (let i = 0; i < workers.length; i++) {
        const worker = workers[i];
        if (checkUserIds.includes(worker.user_id)) {
          if (!json[worker.user_id]) {
            json[worker.user_id] = {
              입문시간: "",
              출문시간: "",
            };
          }

          // 종료시간, 연장시간을 체크해야 할까?
          if (new Date(worker.created_at).format("yyyy-MM-dd") >= new Date().format("yyyy-MM-dd")) {
            if (worker.data === "입문") {
              // 입문 시간중 가장 빠른 시간을 저장
              if (!json[worker.user_id].입문시간) {
                json[worker.user_id].입문시간 = worker.created_at;
              } else if (new Date(json[worker.user_id].입문시간) > new Date(worker.created_at)) {
                json[worker.user_id].입문시간 = worker.created_at;
              }
            }

            if (worker.data === "출문") {
              // 출문 시간중 가장 늦은 시간을 저장
              if (!json[worker.user_id].출문시간) {
                json[worker.user_id].출문시간 = worker.created_at;
              } else if (new Date(json[worker.user_id].출문시간) < new Date(worker.created_at)) {
                json[worker.user_id].출문시간 = worker.created_at;
              }
            }
          }
        }
      }

      let status = 0;
      const userIds = Object.keys(json);
      // 모든 사용자의 출문시간이 존재 하면 출문
      if (userIds.length > 0 && userIds.every((userId) => json[userId].출문시간)) status = this.steps.indexOf("출문");
      // 사용자 중 한명이라도 입문시간이 존재하면 입문
      else if (userIds.some((userId) => json[userId].입문시간)) status = this.steps.indexOf("입문");

      return Math.max(body.상태, status);
    },

    async loadPostList(boardId) {
      // 로딩 상태 활성화
      this.isLoading = true;

      const cacheKey = `graph3-${this.graphId}-${boardId}`;
      const cacheExpiryKey = `${cacheKey}-expiry`;

      // 캐시된 데이터 확인
      const cachedData = localStorage.getItem(cacheKey);
      const cacheExpiry = localStorage.getItem(cacheExpiryKey);
      const currentTime = new Date().getTime();

      // 캐시가 유효한지 확인 (1분 = 60000 밀리초)
      // if (cachedData && cacheExpiry && currentTime < parseInt(cacheExpiry)) {
      //   console.log('Using cached data for', cacheKey);
      //   this.series = JSON.parse(cachedData);
      //
      //   // 캐시된 데이터를 사용해도 약간의 지연을 두어 로딩 애니메이션 표시
      //   setTimeout(() => {
      //     this.isLoading = false;
      //   }, 300);
      //
      //   return;
      // }

      // 캐시가 없거나 만료된 경우 새 데이터 로드
      const conditions = [];
      // 당일 검색
      conditions.push({ key: "body.작업허가.작업시작일시", operator: ">=", value: new Date().format("yyyy-MM-dd") });
      conditions.push({ key: "body.작업허가.작업시작일시", operator: "<", value: new Date().addDays(1).format("yyyy-MM-dd") });

      const options = {
        page: 1,
        perPage: 10000,
        projectId: this.$route.params.proj_id,
        boardId,
        conditions,
        withMeta: true,
        withoutRelation: true,
        metaKeys: ["body.작업정보.작업구역.region.%", "body.상태", "body.작업허가.작업승인.상태", "body.작업허가.작업종료.상태"],
      };

      try {
        let list = [];
        let list2 = [];
        if (boardId === 981) {
          [list, list2] = await Promise.all([this._loadDefragmentation(options), this._loadDefragmentation({ ...options, boardId: 986 })]);

          list.push(...list2);
        } else {
          list = await this._loadDefragmentation(options);
        }
        console.log("list", list);

        const convertList = this.convertList(boardId, list);
        console.log("convertList", convertList);
        this.series = this.updateSeriesData(convertList, this.series);
        console.log("series", this.series);

        // 결과 캐싱 (1분 동안 유효)
        localStorage.setItem(cacheKey, JSON.stringify(this.series));
        localStorage.setItem(cacheExpiryKey, (currentTime + 60000).toString());
      } catch (error) {
        console.error("데이터 로드 중 오류 발생:", error);
      } finally {
        // 로딩 상태 비활성화
        this.isLoading = false;
      }
    },

    // 전체 목록을 다운로드 받기 위해 사용
    // FactoryAccessDashboard.vue 와 동일
    async _loadDefragmentation(options) {
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      const list = [];
      list.push(...response.data);
      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        list.push(...(await this._loadDefragmentation(options)));
      }
      return list;
    },

    // 그래프에서 사용할 수 있도록 변환
    convertList(boardId, list) {
      if (!list || list.length === 0) {
        return [];
      }

      const dataPerRegion = {}; // 공장별 데이터
      for (const regionName of this.categories) {
        dataPerRegion[regionName] = {
          등록: 0,
          작업중: 0,
          작업완료: 0,
        };
      }
      for (const item of list) {
        const body = item.postContents.body; // JSON.parse(item.post_content).body
        const region = body.작업정보.작업구역.region;
        // const step = this.statusNumber(body, item.qr_reads) // 입출문상태: 1:입문, 4:출문 (loadPostList 함수에서 설정)

        let 상태 = body.상태;

        // "등록" 상태이면서, 값이 비어있는 레코드가 있어서,
        // 이 경우에는 976 게시판의 검증 로직을 적용한다.
        if (!상태) {
          const 작업승인상태 = (body.작업허가 && body.작업허가.작업승인 && body.작업허가.작업승인.상태) || null;
          const 작업종료상태 = (body.작업허가 && body.작업허가.작업종료 && body.작업허가.작업종료.상태) || null;

          if (작업승인상태 !== "승인" && 작업종료상태 !== "승인") {
            상태 = 0;
          }
        }

        // 출입이 없는 등록 상태는 데이터에서 제외 (외부작업, 장비)
        // if (boardId !== 981 && step === 0) {
        //   continue;
        // }

        if (dataPerRegion[region.name] === undefined) {
          dataPerRegion[region.name] = {
            등록: 0,
            작업중: 0,
            작업완료: 0,
          };
        }

        dataPerRegion[region.name][this.steps[상태]] += 1;
      }

      const convertList = [];
      for (const regionName of this.categories) {
        convertList.push(dataPerRegion[regionName]);
      }
      return convertList;
    },

    // convertList 함수에서 변환된 데이터를 series에 적용
    updateSeriesData(dataArray, series) {
      return series.map((s) => ({
        ...s,
        data: dataArray.map((d) => d[s.step] || 0), // step에 해당하는 값이 없으면 0
      }));
    },

    // 캐시 강제 리프레시를 위한 새 메서드 추가 (필요시)
    refreshData() {
      // 캐시 키 생성
      const cacheKey = `graph-${this.graphId}-${this.boardId}`;
      const cacheExpiryKey = `${cacheKey}-expiry`;

      // 캐시 삭제
      localStorage.removeItem(cacheKey);
      localStorage.removeItem(cacheExpiryKey);

      // 데이터 새로 로드
      this.loadPostList(this.boardId);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-border {
  font-size: 12px;
  width: 55px;
  border-radius: 999px;
  display: inline-block;
  text-align: center;
  cursor: pointer;

  border: 1px solid #cdcdcd;
  font-weight: 500;

  &.active {
    background-color: #6670cb;
    color: white;
  }
}
</style>
